// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* anfahrt.css */

.app__anfahrt_container {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 1550px;
  padding: 40px 143px;
}

.app__anfahrt_container_heading {
  font-size: 4rem;
  font-weight: bold;
  margin-bottom: 20px;
  font-family: "SawtonIndustrial-Bold";
}

.app__anfahrt_container_text {
  font-size: 1.5rem;
  line-height: 1.5;
  max-width: 450px;
  min-width: 280px;
  font-family: "SawtonIndustrial-Light";
}

.app__anfahrt_container_googlmaps {
  max-width: 100%;
  border: none;
  border-radius: 15px;
  min-width: 300px;
}
.app__anfahrt_container_description {
  padding-right: 25px;
}
@media (max-width: 768px) {
  .app__anfahrt_container {
    flex-direction: column;
  }

  .app__anfahrt_container_text {
    margin-bottom: 20px;
    font-size: 1.2rem;
  }
  .app__anfahrt_container_heading {
    font-size: 3rem;
  }
}
@media (max-width: 320px) {
  .app__anfahrt_container_googlmaps {
    min-width: 280px;
  }
}
@media (max-width: 300px) {
  .app__anfahrt_container_googlmaps {
    min-width: 250px;
  }

  .app__anfahrt_container_description {
    max-width: 270px;
    padding: 10px;
    padding-top: 0;
  }
  .app__anfahrt_container_heading {
    padding: 10px;
    padding-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/Anfahrt/anfahrt.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":["/* anfahrt.css */\n\n.app__anfahrt_container {\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1550px;\n  padding: 40px 143px;\n}\n\n.app__anfahrt_container_heading {\n  font-size: 4rem;\n  font-weight: bold;\n  margin-bottom: 20px;\n  font-family: \"SawtonIndustrial-Bold\";\n}\n\n.app__anfahrt_container_text {\n  font-size: 1.5rem;\n  line-height: 1.5;\n  max-width: 450px;\n  min-width: 280px;\n  font-family: \"SawtonIndustrial-Light\";\n}\n\n.app__anfahrt_container_googlmaps {\n  max-width: 100%;\n  border: none;\n  border-radius: 15px;\n  min-width: 300px;\n}\n.app__anfahrt_container_description {\n  padding-right: 25px;\n}\n@media (max-width: 768px) {\n  .app__anfahrt_container {\n    flex-direction: column;\n  }\n\n  .app__anfahrt_container_text {\n    margin-bottom: 20px;\n    font-size: 1.2rem;\n  }\n  .app__anfahrt_container_heading {\n    font-size: 3rem;\n  }\n}\n@media (max-width: 320px) {\n  .app__anfahrt_container_googlmaps {\n    min-width: 280px;\n  }\n}\n@media (max-width: 300px) {\n  .app__anfahrt_container_googlmaps {\n    min-width: 250px;\n  }\n\n  .app__anfahrt_container_description {\n    max-width: 270px;\n    padding: 10px;\n    padding-top: 0;\n  }\n  .app__anfahrt_container_heading {\n    padding: 10px;\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
